import apiServices from '@/services/yungol-services'

const BASE_URL = 'email-templates'

export async function fetchTemplates(filters = {}) {
  const params = new URLSearchParams(filters).toString()
  const url = params ? `${BASE_URL}?${params}` : BASE_URL
  const response = await apiServices.get(url)
  return response.data
}

export async function fetchTemplate(id) {
  const response = await apiServices.get(`${BASE_URL}/${id}`)
  return response.data
}

export async function fetchTemplateByType(module, emailType, proceso, clienteId) {
  const params = []
  if (proceso) {
    params.push('proceso=' + proceso)
  }
  if (clienteId === null) {
    params.push('clienteId=null')
  } else if (clienteId) {
    params.push('clienteId=' + clienteId)
  }
  const query = params.length > 0 ? '?' + params.join('&') : ''
  const response = await apiServices.get(BASE_URL + '/by-type/' + module + '/' + emailType + query)
  return response.data
}

export async function saveTemplate(data) {
  const response = await apiServices.post(`${BASE_URL}/save`, data)
  return response.data
}

export async function deleteTemplate(id) {
  const response = await apiServices.delete(`${BASE_URL}/${id}`)
  return response.data
}

export async function fetchDefaults(module = null) {
  const query = module ? `?module=${module}` : ''
  const response = await apiServices.get(`${BASE_URL}/defaults${query}`)
  return response.data
}



// WEBPACK FOOTER //
// ./src/components/shared/emailEditor/api.js